import { createSlice } from "@reduxjs/toolkit";
import {
  addCategory,
  addProduct,
  updateCategory,
  updateProduct,
  deleteCategory,
  deleteProduct,
  getCategories,
  getProducts,
} from "./actions/productCategory";

const initialState = {
  loading: false,
  isEditing: false,
  categories: null,
  totalCategories: 0,
  category: null,
  products: null,
  totalProducts: 0,
  product: null,
};

export const productCategorySlice = createSlice({
  name: "productCategory",
  initialState,
  reducers: {
    setCategory: (state, action) => {
      const category = state.categories.find(
        (cat) => cat.id === action.payload
      );
      state.category = category;
    },
    setProduct: (state, action) => {
      const product = state.products.find((pro) => pro.id === action.payload);
      state.product = product;
    },
    setIsEditing: (state, action) => {
      state.isEditing = action.payload;
    },
  },
  extraReducers: (builder) => {
    // categories
    builder
      .addCase(getCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.categories = data;
        state.totalCategories = count;
      })
      .addCase(getCategories.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(addCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCategory.fulfilled, (_, action) => {
        window.location.hash = "#/profile/productCategory?type=category";
      })
      .addCase(addCategory.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.isEditing = false;
        state.category = action.payload;
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.isEditing = false;
        state.loading = false;
      });

    builder.addCase(deleteCategory.fulfilled, (_, action) => {
      window.location.hash = "#/profile/productCategory?type=category";
    });

    // products
    builder
      .addCase(getProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.products = data;
        state.totalProducts = count;
      })
      .addCase(getProducts.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(addProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(addProduct.fulfilled, (_, action) => {
        window.location.hash = "#/profile/productCategory?type=product";
      })
      .addCase(addProduct.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.isEditing = false;
        state.product = action.payload;
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.isEditing = false;
        state.loading = false;
      });

    builder.addCase(deleteProduct.fulfilled, (_, action) => {
      window.location.hash = "#/profile/productCategory?type=product";
    });
  },
});

export const { setCategory, setProduct, setIsEditing } =
  productCategorySlice.actions;

export default productCategorySlice.reducer;
